import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    badgeColor: Yup.string().required('Required').nullable(),
    badgeName: Yup.string().required('Required').nullable(),
    name: Yup.string().required('Required').nullable(),
  });
